(function () {
    angular.module('st')
        .controller('CelebrationSearchController', [
            '$rootScope', '$scope', '$sce', "$http",
            function ($rootScope, $scope, $sce, $http) {
                var ctrl = this;
                ctrl.assignPolyfill = function () {
                    if (typeof Object.assign !== 'function') {
                        // Must be writable: true, enumerable: false, configurable: true
                        Object.defineProperty(Object, "assign", {
                            value: function assign(target, varArgs) { // .length of function is 2
                                'use strict';
                                if (target === null || target === undefined) {
                                    throw new TypeError('Cannot convert undefined or null to object');
                                }

                                var to = Object(target);

                                for (var index = 1; index < arguments.length; index++) {
                                    var nextSource = arguments[index];

                                    if (nextSource !== null && nextSource !== undefined) {
                                        for (var nextKey in nextSource) {
                                            // Avoid bugs when hasOwnProperty is shadowed
                                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                                to[nextKey] = nextSource[nextKey];
                                            }
                                        }
                                    }
                                }
                                return to;
                            },
                            writable: true,
                            configurable: true
                        });
                    }
                }
                ctrl.assignPolyfill();
                ctrl.results = []
                $rootScope.searchResults = {}
                ctrl.resultTypes = ['Movies','Deals','Events', 'FAQs','Cinema Locations', 'Upcoming Films']
                $rootScope.$on('stSearchUpdated', function (value) {
                });

                $rootScope.$on('searchCleared', function (value) {
                    ctrl.results = []
                });

                $scope.$watch('$parent.ctrl.results.Results', function (value) {
                    if (value == null || value == undefined) {
                        return;
                    }

                    ctrl.results = [];

                    for (var i = 0; i < value.length; i++) {
                        var result = value[i];
                        var type = ctrl.GetType(result['ContentType']);

                        ctrl.results[type] = ctrl.results[type] == null ? [] : ctrl.results[type];
                        ctrl.results[type].push(result)
                    }

                    //change upcoming film results if both films and upcoming film results are present. i.e. /film/ instead of /upcomingfilm/ if a film exists
                    if (ctrl.results) {                        
                        var hasFilms = !!(ctrl.results.Movies && ctrl.results.Movies.length > 0);
                        var hasUpcoming = !!(ctrl.results['Upcoming Films'] && ctrl.results['Upcoming Films'].length > 0);                        
                        var updatedUpcomingFilms = [];

                        //if both are in results, remove dupe upcoming films
                        if (hasFilms && hasUpcoming) {
                            console.log('upcoming results', ctrl.results['Upcoming Films'].length);
                            ctrl.results['Upcoming Films'].forEach((upcoming) => {
                                if (ctrl.results.Movies.find(e => e.Title === upcoming.Title)) {
                                    //we found a result so skip this
                                } else {
                                    //we didnt find a match, so keep this result
                                    updatedUpcomingFilms.push(upcoming);
                                }
                            });

                            //update list to show only unique upcoming films that are not also in films
                            ctrl.results['Upcoming Films'] = updatedUpcomingFilms;
                            console.log('upcoming results', ctrl.results['Upcoming Films'].length);
                        }
                    }

                    console.log('results', ctrl.results);
                    $rootScope.searchResults = Object.assign({},ctrl.results);
                });

                ctrl.GetType = function (contentType) {
                    var type = '';
                    if (contentType.indexOf('.Film') > -1) {
                        type = 'Movies';
                    } else if (contentType.indexOf('.Deal') > -1) {
                        type = 'Deals';
                    } else if (contentType.indexOf('.Cinemaevent') > -1) {
                        type = 'Events';
                    } else if (contentType.indexOf('.FrequentlyAskedQuestion') > -1) {
                        type = 'FAQs';
                    } else if (contentType.indexOf('.Cinema') > -1) {
                        type = 'Cinema Locations';
                    } else if (contentType.indexOf('.Upcomingfilm') > -1) {
                        type = 'Upcoming Films';
                    } 

                    return type;
                }
            }]);
})();

